<app-companies-company-info-card [company]="company"></app-companies-company-info-card>
@if (company && products && applications && companyProducts && companyApplications) {
  <app-companies-company-services-card [company]="company" [products]="products" [applications]="applications" [companyProducts]="companyProducts" [companyApplications]="companyApplications"></app-companies-company-services-card>
}
<div>
  <app-companies-company-image-card [company]="company" [size]="'S'"></app-companies-company-image-card>
  <app-companies-company-image-card [company]="company" [size]="'M'"></app-companies-company-image-card>
</div>
<div>
  <app-companies-company-image-card [company]="company" [size]="'L'"></app-companies-company-image-card>
  <app-companies-company-image-card [company]="company" [size]="'Xl'"></app-companies-company-image-card>
</div>